import RequestUrls from '@Constants/RequestUrlsConstants';
import MessageBroker from '@Services/MessageBroker';

export async function getSavedHistory() {
  return MessageBroker.send(RequestUrls.getHistory, null, { cache: false });
}

export async function saveRecentHistoryApi(historyItem) {
  return MessageBroker.send(RequestUrls.saveRecentHistory, historyItem);
}

export async function saveHistory(historyItem) {
  return MessageBroker.send(RequestUrls.saveHistory, historyItem);
}

export async function modifyHistory(historyItem) {
  return MessageBroker.send(RequestUrls.modifyHistory, historyItem);
}

export async function removeHistory(historyItem) {
  return MessageBroker.send(RequestUrls.removeHistory, historyItem);
}

export async function deleteHistory(itemtobeDeleted, type) {
  const url = type.toLowerCase() === 'recent' ? RequestUrls.deleteRecentHistory : RequestUrls.deleteSavedHistory;
  return MessageBroker.send(url, null, null, itemtobeDeleted);
}

export async function fetchRecentHistory({ page, size, sort }) {
  return MessageBroker.send(RequestUrls.fetchRecentHistory, { page, size, sort });
}

export async function searchRecentHistory({ page, size, sort, query }) {
  return MessageBroker.send(RequestUrls.searchRecentHistory, { page, size, sort, query });
}

export async function getHistoryTypes() {
  return MessageBroker.send(RequestUrls.getHistoryTypes);
}

export async function restoreHistory(historyItem) {
  return MessageBroker.send(RequestUrls.restoreHistory, historyItem);
}
